<template>
  <div
    v-if="!party.hideByDefault || this.seats > 0"
    class="seats-by-party"
    :style="`width: ${getWidth}px`">
    <div class="party-info">
      <div>{{ party.name }} <b class="ml-1">{{ seats }}</b></div>
    </div>
    <div class="party-seats">
      <div v-for="(seat, index) in seats" :key="index" class="seat" :style="`background-color: ${party.color};`"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    party: {
      type: Object,
      required: true
    },
    projection: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    seats () {
      return this.projection ? parseInt(this.item.overall_seat_projection_21) || 0 : parseInt(this.item.total_seat_count) || 0
    },
    getWidth () {
      const rows = 14
      const seatsWidth = 9
      const margin = 2
      const maxSeats = this.seats

      const columns = Math.ceil(maxSeats / rows)
      return (columns * seatsWidth) + (columns * margin)
    }
  }
}
</script>

<style>
.seats-by-party {
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 10px;
  min-width: 105px;
  vertical-align: top;
}

.party-info {
  font-size: 14px;
  margin-bottom: 5px;
}

.party-seats {
  line-height: 10px;
}

.seat {
  display: inline-block;
  width: 9px;
  height: 9px;
  border-radius: 2px;
  margin-right: 2px;
}
</style>
